import { Select, SelectProps, Typography } from "@mui/material";
import { Fragment, ReactNode } from "react";

type SelectFieldProps = {
  title: string;
  children: ReactNode;
  registration: object;
  errorMessage: string | undefined;
} & SelectProps;

export const CreateTicketServiceNowSelectField = ({
  registration,
  children,
  ...props
}: SelectFieldProps) => {
  return (
    <Fragment>
      <Typography variant="body1" gutterBottom sx={{ mb: 1, fontWeight: 700 }}>
        {props.title}
      </Typography>
      <Select
        data-test-id="servicenow-ticket-select-input"
        fullWidth
        error={Boolean(props.errorMessage)}
        sx={{
          "&.MuiInputBase-root": {
            bgcolor: "code.background",
          },
        }}
        {...props}
        {...registration}
      >
        {children}
      </Select>
    </Fragment>
  );
};
